import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import useContentEditorUrl from 'personalization-lib/hooks/nav/useContentEditorUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const AssetEditorLink = ({
  assetType,
  assetId,
  strategyId,
  external = false
}) => {
  const editorUrl = useContentEditorUrl({
    assetCoordinates: {
      source: assetType,
      id: Number(assetId)
    },
    strategyId
  });
  return /*#__PURE__*/_jsx(Link, {
    href: editorUrl,
    external: external,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `personalizationLib.shared.assetEditorLink.${assetType}`
    })
  });
};
export default AssetEditorLink;